import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-4 overflow-hidden bg-cream" data-id="element-102">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-103">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="text-left space-y-6 z-10" data-id="element-104">
          <span className="inline-block px-4 py-1.5 rounded-full bg-green/10 text-green font-semibold text-sm tracking-wide mb-2" data-id="element-105">
            Protocolo 10 Días
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-[1.1]" data-id="element-106">
            De croquetas a comida real…{' '}
            <span className="text-green" data-id="element-107">sin pánico.</span>
          </h1>

          <p className="text-lg md:text-xl text-navy/80 leading-relaxed max-w-lg" data-id="element-108">
            Si alguna vez te quedaste mirando el plato de tu perro pensando:
            <span className="italic font-medium" data-id="element-109">
              {' '}
              "Sé que podría comer mejor… pero ¿y si lo cambio y le cae mal?"
            </span>
            — Este protocolo es para ese momento exacto.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-110">
            <Button size="lg" className="w-full sm:w-auto group" onClick={() => document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-111">
              Quiero la Ruta de 10 Días
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-112" />
            </Button>
          </div>

          <div className="flex items-center gap-2 text-sm text-navy/60 font-medium pt-2" data-id="element-113">
            <CheckCircle2 className="h-4 w-4 text-green" data-id="element-114" />
            <span data-id="element-115">PDF descargable</span>
            <span className="mx-1" data-id="element-116">·</span>
            <CheckCircle2 className="h-4 w-4 text-green" data-id="element-117" />
            <span data-id="element-118">Tablas imprimibles</span>
            <span className="mx-1" data-id="element-119">·</span>
            <CheckCircle2 className="h-4 w-4 text-green" data-id="element-120" />
            <span data-id="element-121">Checklist incluido</span>
          </div>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        rotate: 2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative z-0" data-id="element-122">
          <div className="absolute inset-0 bg-green/5 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-123" />
          <img src="https://cdn.magicpatterns.com/uploads/eKTqS9LvPCK2vNaDRKf1Ra/heylloyd-image-1770491550348.png" alt="Protocolo 10 Días PDF en Tablet" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white" data-id="element-124" />
        </motion.div>
      </div>
    </section>;
}